var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#FEFEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#64696C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3071_32939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 18,
    height: 18
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3071_32939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 21.498C12.675 21.498 11.5938 21.2887 10.7563 20.8699C9.91875 20.4512 9.5 19.9105 9.5 19.248C9.5 18.8105 9.68125 18.4293 10.0438 18.1043C10.4062 17.7793 10.9063 17.523 11.5438 17.3355L11.975 18.7605C11.7625 18.823 11.5688 18.9012 11.3938 18.9949C11.2188 19.0887 11.1 19.173 11.0375 19.248C11.2 19.448 11.575 19.623 12.1625 19.773C12.75 19.923 13.3625 19.998 14 19.998C14.6375 19.998 15.2531 19.923 15.8469 19.773C16.4406 19.623 16.8188 19.448 16.9813 19.248C16.9188 19.173 16.8 19.0887 16.625 18.9949C16.45 18.9012 16.2563 18.823 16.0438 18.7605L16.475 17.3355C17.1125 17.523 17.6094 17.7793 17.9656 18.1043C18.3219 18.4293 18.5 18.8105 18.5 19.248C18.5 19.9105 18.0813 20.4512 17.2437 20.8699C16.4062 21.2887 15.325 21.498 14 21.498ZM14 16.4918C14.225 16.0793 14.4625 15.7012 14.7125 15.3574C14.9625 15.0137 15.2063 14.6855 15.4438 14.373C15.9062 13.773 16.275 13.2324 16.55 12.7512C16.825 12.2699 16.9625 11.673 16.9625 10.9605C16.9625 10.1355 16.675 9.43555 16.1 8.86055C15.525 8.28555 14.825 7.99805 14 7.99805C13.175 7.99805 12.475 8.28555 11.9 8.86055C11.325 9.43555 11.0375 10.1355 11.0375 10.9605C11.0375 11.673 11.175 12.2699 11.45 12.7512C11.725 13.2324 12.0938 13.773 12.5563 14.373C12.7938 14.6855 13.0375 15.0137 13.2875 15.3574C13.5375 15.7012 13.775 16.0793 14 16.4918ZM14 19.248C13.8625 19.248 13.7375 19.2074 13.625 19.1262C13.5125 19.0449 13.4313 18.9355 13.3813 18.798C13.0938 17.9105 12.7313 17.1668 12.2938 16.5668C11.8563 15.9668 11.4313 15.3918 11.0188 14.8418C10.6188 14.2918 10.2719 13.723 9.97812 13.1355C9.68437 12.548 9.5375 11.823 9.5375 10.9605C9.5375 9.71055 9.96875 8.6543 10.8312 7.7918C11.6937 6.9293 12.75 6.49805 14 6.49805C15.25 6.49805 16.3063 6.9293 17.1688 7.7918C18.0312 8.6543 18.4625 9.71055 18.4625 10.9605C18.4625 11.823 18.3188 12.548 18.0312 13.1355C17.7437 13.723 17.3938 14.2918 16.9813 14.8418C16.5813 15.3918 16.1594 15.9668 15.7156 16.5668C15.2719 17.1668 14.9062 17.9105 14.6188 18.798C14.5688 18.9355 14.4875 19.0449 14.375 19.1262C14.2625 19.2074 14.1375 19.248 14 19.248ZM14 12.5543C14.4375 12.5543 14.8125 12.398 15.125 12.0855C15.4375 11.773 15.5938 11.398 15.5938 10.9605C15.5938 10.523 15.4375 10.148 15.125 9.83555C14.8125 9.52305 14.4375 9.3668 14 9.3668C13.5625 9.3668 13.1875 9.52305 12.875 9.83555C12.5625 10.148 12.4062 10.523 12.4062 10.9605C12.4062 11.398 12.5625 11.773 12.875 12.0855C13.1875 12.398 13.5625 12.5543 14 12.5543Z",
    fill: "#282828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisited);
export default __webpack_public_path__ + "static/media/Visited.58c8d6bdee5f16f4f21335b49d7e7df7.svg";
export { ForwardRef as ReactComponent };